import React from "react";
import SearchAndFilter from "../../SearchAndFilter";

import { Collapse, Table } from "antd";
import { useDispatch } from "react-redux";
import { setDrawerActiveTab } from "../../../../../store/slices/homeSlice";
import BehaviourSupportPlanDrawer from "../../../../../components/BehaviourSupportPlanDrawer";
import moment from "moment";

const FormsAndMoules = () => {
  const itemData = [
    {
      title: "2.1 Behaviour Support in the NDIS Policy and Procedure",
      legislation: true,
      policiesAndProcedures: true,
      forms: true,
    },
    {
      title: "2.2 Restrictive Practices Policy and Procedure",
      legislation: true,
      policiesAndProcedures: true,
      forms: true,
    },
    {
      title:
        "2.3 Functional Behavioural Assessment and Behaviour Support Plans Policy and Procedure",
      legislation: true,
      policiesAndProcedures: true,
      forms: true,
    },
    {
      title:
        "2.4 Supporting the Implementation of the Behaviour Support Plan Policy and Procedure",
      legislation: false,
      policiesAndProcedures: true,
      forms: true,
    },
    {
      title:
        "2.5 Behaviour Support Plan Monitoring and Review Policy and Procedure",
      legislation: false,
      policiesAndProcedures: true,
      forms: true,
    },
    {
      title:
        "2.6 Reportable Incidents Involving the Use of a Restrictive Practice Policy and Procedure",
      legislation: false,
      policiesAndProcedures: false,
      forms: true,
    },
    {
      title: "2.7 Interim Behaviour Support Plans Policy and Procedure",
      legislation: false,
      policiesAndProcedures: false,
      forms: true,
    },
  ];

  const items = [
    {
      title: "NDIS Verification Pack",
      data: [
        { title: "NDIS POLICY AND PROCEDURE MANUAL", data: itemData },
        { title: "PARTECIPANT FORMS", data: itemData },
      ],
    },
    {
      title: "NDIS Certification Pack (Core Module)",
      data: [
        { title: "NDIS POLICY AND PROCEDURE MANUAL", data: itemData },
        { title: "PARTECIPANT FORMS", data: itemData },
      ],
    },
    {
      title: "NDIS Module 1: High Intensity",
      data: [
        { title: "NDIS POLICY AND PROCEDURE MANUAL", data: itemData },
        { title: "PARTECIPANT FORMS", data: itemData },
      ],
    },
    {
      title: "NDIS Module 2: Behaviour Support",
      data: [
        { title: "NDIS POLICY AND PROCEDURE MANUAL", data: itemData },
        { title: "PARTECIPANT FORMS", data: itemData },
      ],
    },
    {
      title: "NDIS Module 3: Early Childhood Support",
      data: [
        { title: "NDIS POLICY AND PROCEDURE MANUAL", data: itemData },
        { title: "PARTECIPANT FORMS", data: itemData },
      ],
    },
    {
      title: "NDIS 4: Support Coordinator",
      data: [
        { title: "NDIS POLICY AND PROCEDURE MANUAL", data: itemData },
        { title: "PARTECIPANT FORMS", data: itemData },
      ],
    },
    {
      title: "NDIS 5: SDA",
      data: [
        { title: "NDIS POLICY AND PROCEDURE MANUAL", data: itemData },
        { title: "PARTECIPANT FORMS", data: itemData },
      ],
    },
  ].map((item, index) => ({
    ...item,
    key: String(index + 1),
    label: item.title,
    children: <CollapseItems data={item.data} />,
    className: index % 2 === 0 ? "gray-panel" : "white-panel",
  }));

  const submissions = [
    {
      formName: "Incident Report",
      submittedBy: "Jane Smith",
      submissionDate: new Date("03/18/25").toDateString(),
      status: "Pending",
      action: "View",
    },
    {
      formName: "Compliance Form",
      submittedBy: "John Doe",
      submissionDate: new Date("03/15/25").toDateString(),
      status: "Approved",
      action: "View",
    },
    {
      formName: "Feedback Survey",
      submittedBy: "Marie Johnson",
      submissionDate: new Date("03/12/25").toDateString(),
      status: "Rejected",
      action: "View",
    },
  ].map((data, index) => {
    return {
      ...data,
      key: String(index + 1),
    };
  });

  const columns = [
    {
      title: "FORM NAME",
      dataIndex: "formName",
      key: "formName",
    },
    {
      title: "SUBMITTED BY",
      dataIndex: "submittedBy",
      key: "submittedBy",
    },
    {
      title: "SUBMISSION DATE",
      dataIndex: "submissionDate",
      key: "submissionDate",
      render: (t) => <span>{moment(t).format("MM/DD/YYYY")}</span>,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "ACTION",
      dataIndex: "action",
      key: "action",
      render: (t) => <span style={{ cursor: "pointer" }}>View</span>,
    },
  ];

  return (
    <>
      <SearchAndFilter title="NDIS Compliance Packs" inputWidth={"large"} />
      <div className="collapseContainer">
        <Collapse
          accordion
          ghost
          items={items}
          defaultActiveKey={["1"]}
          onChange={() => {}}
        />
      </div>
      <SearchAndFilter title="Submitted Forms" />

      <Table
        pagination={false}
        dataSource={submissions}
        columns={columns}
        rowClassName={(_, index) => (index % 2 === 1 ? "altRow" : "normalRow")}
      />
      <BehaviourSupportPlanDrawer />
    </>
  );
};

const CollapseItems = ({ data }) => {
  const dispatch = useDispatch();

  const handleOpenDrawer = (tab) => {
    dispatch(setDrawerActiveTab(tab));
  };

  return (
    <div className="collapseWrapper">
      {data?.map((item) => {
        return (
          <div className="collapseItemBox">
            <div className="collapseItemHeader">
              <p>{item.title}</p>
            </div>
            {item?.data?.map((item, index, arr) => {
              const bgColor = index % 2 === 0 ? "bgWhite" : "bgGray";
              const isLast = index === arr.length - 1;
              const borderRadiusClass = isLast ? "borderRadius" : "";

              return (
                <div
                  key={index}
                  className={`collapseItemRow ${bgColor} ${borderRadiusClass}`}
                >
                  <div className="collapseItemRowLeft">
                    <p>{item?.title}</p>
                  </div>
                  <div className="collapseActions">
                    {item.legislation && (
                      <p
                        onClick={() => handleOpenDrawer("Legislation")}
                        type="text"
                      >
                        Legislation
                      </p>
                    )}
                    {item.policiesAndProcedures && (
                      <p
                        onClick={() =>
                          handleOpenDrawer("Policies & Procedures")
                        }
                        type="text"
                      >
                        Policies & Procedures
                      </p>
                    )}
                    {item.forms && (
                      <p onClick={() => handleOpenDrawer("Forms")} type="text">
                        Forms
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default FormsAndMoules;
